import automobyApi from '../Api';

export const useComment = (carId) => { 
   const fetchComments = () => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        car_id: carId,
      };
  
      automobyApi
        .post("/comment/list", requestData)
        .then(response => {
          resolve(response.data.comments);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const addComment = (newComment) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/comment/add", newComment)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }; 

  const removeComment = (commentId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        comment_id: commentId
      };
  
      automobyApi
        .post("/comment/remove", requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

   
  const commentService = {
    fetchComments: fetchComments,
    addComment: addComment, 
    removeComment: removeComment,
   };
  

  return { commentService };
 
}